var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[_c('div',{staticClass:"video__container",class:{
      video__container: true,
      "video__container--hide-picture": _vm.showVideo,
    },style:({
      "background-image": "url(" + _vm.previewSrc + ")",
    })},[(!_vm.showVideo)?_c('a',{staticClass:"video__button",on:{"click":function($event){return _vm.playVideo($event)}}}):_vm._e(),(_vm.showVideo)?_c('iframe',{staticClass:"video__iframe",attrs:{"src":_vm.src,"allow":"autoplay; encrypted-media","allowfullscreen":""}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }